import { render, staticRenderFns } from "./datapoints.vue?vue&type=template&id=d41cfb64&scoped=true&"
import script from "./datapoints.vue?vue&type=script&lang=js&"
export * from "./datapoints.vue?vue&type=script&lang=js&"
import style0 from "./datapoints.vue?vue&type=style&index=0&id=d41cfb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41cfb64",
  null
  
)

component.options.__file = "datapoints.vue"
export default component.exports